"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _commonAccordion = require("@mmc/common-accordion");
var _text = require("@mmc/text");
var _navigationHeader = _interopRequireDefault(require("../styles/navigation-header.css"));
var _productLinks = _interopRequireDefault(require("./product-links"));
var _clickEvent = function clickEvent(event, name) {
  event.preventDefault();
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'navclick',
      component: 'top_nav',
      action: "tab_click",
      section_name: name,
      click_text: event.target.innerText
    });
  }
};
var ProductAccordion = function ProductAccordion(_ref) {
  var products = _ref.products,
    theme = _ref.theme,
    name = _ref.name,
    addPriceDisclaimer = _ref.addPriceDisclaimer,
    priceDisclaimerId = _ref.priceDisclaimerId,
    disclaimerData = _ref.disclaimerData,
    market = _ref.market,
    config = _ref.config,
    currentPath = _ref.currentPath,
    keyHandlerMethod = _ref.keyHandlerMethod,
    mobileNavActive = _ref.mobileNavActive,
    hideArrows = _ref.hideArrows;
  var totalSetSize = 10;
  var renderPanels = function renderPanels(panelData) {
    if (panelData === void 0) {
      panelData = [];
    }
    var panelMarkup = [];
    panelData.forEach(function (item) {
      panelMarkup.push(/*#__PURE__*/_react["default"].createElement("h3", null, item.vehiclesHeader));
      var panelBody = /*#__PURE__*/_react["default"].createElement("div", {
        className: "products"
      }, /*#__PURE__*/_react["default"].createElement(_productLinks["default"], {
        products: item.vehicles,
        theme: theme,
        totalSetSize: totalSetSize,
        name: name,
        sectionName: item.vehiclesHeader,
        addPriceDisclaimer: addPriceDisclaimer,
        priceDisclaimerId: priceDisclaimerId,
        disclaimerData: disclaimerData,
        market: market,
        config: config,
        currentPath: currentPath,
        keyHandlerMethod: keyHandlerMethod,
        mobileNavActive: mobileNavActive,
        hideArrows: hideArrows,
        categoryName: item.vehiclesHeader
      }));
      panelMarkup.push(panelBody);
    });
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, panelMarkup);
  };
  return /*#__PURE__*/_react["default"].createElement(_commonAccordion.CommonAccordion, {
    theme: theme,
    headerClasses: [_navigationHeader["default"].accordionNoBorder, _navigationHeader["default"].accordionHeaderClasses],
    panelClasses: [_navigationHeader["default"].accordionNoBorder, _navigationHeader["default"].accordionPanelClasses],
    clickEvent: function clickEvent() {
      return _clickEvent(event, name);
    }
  }, renderPanels(products));
};
ProductAccordion.displayName = 'ProductAccordion';
var _default = ProductAccordion;
exports["default"] = _default;